import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGooglePlay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.62 3.45L13.6 12L4.62 20.55C4.24 20.32 4 19.9 4 19.4V4.6C4 4.1 4.24 3.68 4.62 3.45Z",
			fill: "#00A0FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.62 3.45C4.9 3.28 5.28 3.26 5.62 3.45L16.6 9.6L13.6 12L4.62 3.45Z",
			fill: "#00D95F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.62 20.55L13.6 12L16.6 14.4L5.62 20.55C5.28 20.74 4.9 20.72 4.62 20.55Z",
			fill: "#FF3A44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.6 9.6L19.9 11.45C20.63 11.86 20.63 12.14 19.9 12.55L16.6 14.4L13.6 12L16.6 9.6Z",
			fill: "#FFD400"
		})
	]
});
export default SvgGooglePlay;
